import { Box, Button, Grid, Paper, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useUser } from "../contexts/useUser";
import ProjectControlPanel from "./ProjectControlPanel";
import Calls from "./Calls";
import MapChart from "./MapChart";
import CostDashboard from "./CostDashbaord";
import CustomerSat from "./CustomerSat";
import SendSummaryEmailBox from "./SendSummaryEmailBox";

const Home = () => {
  const navigate = useNavigate();
  const { project, user } = useUser();

  return (
    <Box p={2}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Paper
            elevation={3}
            sx={{ borderRadius: 3, border: "1px solid #444" }}
          >
            <Box p={2}>
              <ProjectControlPanel />

              {project && (
                <>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => navigate(`projects/edit/${project?.id}`)}
                  >
                    Project Settings...
                  </Button>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  <SendSummaryEmailBox project={project} user={user} />
                  {(project?.summaryEmailPeriod ?? 0) > 0 && (
                    <Typography variant="caption" color="text.secondary">
                      {" "}
                      Scheduled every:
                      {project?.summaryEmailPeriod === 1 ? " day" : " " + project?.summaryEmailPeriod + " days"} (next
                      email:{" "}
                      {project?.lastSummaryEmailSentAt
                        ? new Date(
                            new Date(project.lastSummaryEmailSentAt).getTime() +
                              (project.summaryEmailPeriod ?? 0) * 24 * 60 * 60 * 1000
                          ).toLocaleString()
                        : "N/A"}
                      )
                    </Typography>
                  )}
                </>
              )}
            </Box>
          </Paper>
        </Grid>

        <Grid item xs={12}>
          <CustomerSat />
        </Grid>

        <Grid item xs={12}>
          <Paper
            elevation={3}
            sx={{ borderRadius: 3, border: "1px solid #444" }}
          >
            <CostDashboard />
          </Paper>
        </Grid>

        <Grid item xs={12} lg={12}>
          <Paper
            elevation={3}
            sx={{ borderRadius: 3, border: "1px solid #444" }}
          >
            <Calls showFilter={true} calls={null} />
          </Paper>
        </Grid>

        <Grid item xs={12}>
          <Paper
            elevation={3}
            sx={{ borderRadius: 3, border: "1px solid #444" }}
          >
            <MapChart />
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Home;

/*            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              height="100%"
            >
              <ServiceMap
                services={[
                  { id: "1", name: "Service 1", calls: 10, status: "healthy" },
                  { id: "2", name: "Service 2", calls: 20, status: "healthy" },
                  { id: "3", name: "Service 3", calls: 30, status: "healthy" },
                  { id: "4", name: "Service 4", calls: 40, status: "healthy" },
                ]}
              />
            </Box>*/
